import React, { useCallback, useEffect } from 'react';
import Header from '../../components/Header/Header';
import createDOMPurify from 'dompurify';
import useGetPageConfig from '../../hooks/useGetPageConfig';
import TermsAndConditionsMovioEN from './translations/en/TermsAndConditions.html';
import TermsAndConditionsFunBoxEN from './translations/en/TermsAndConditionsFunBox.html';
import TermsAndConditionsEntertainuEN from './translations/en/TermsAndConditionsEntertainu.html';
import TermsAndConditionsFlixvidEN from './translations/en/TermsAndConditionsFlixvid.html';
import TermsAndConditionsMixstreamflixEN from './translations/en/TermsAndConditionsMixstreamflix.html';
import TermsAndConditionsSparkstreamEN from './translations/en/TermsAndConditionsSparkstream.html';
import TermsAndConditionZvaigzdeplay from './translations/en/TermsAndConditionZvaigzdeplay.html';
import TermsAndConditionMobiotv from './translations/en/TermsAndConditionMobiotv.html';
import { config, getHostname } from '../../constants/domainConfig';
import { dashboardURL } from '../../constants/dashboardURL';
import PageLoader from '../../components/Loaders/PageLoader';
import TermsAndConditionsNonton from './translations/en/TermsAndConditionsNonton.html';
import TermsAndConditionsNontonID from './translations/id/TermsAndConditionsNonton_ID.html';
import TermsAndConditionsPlaynixzoneBG from './translations/bg/TermsAndConditions_bg.html';

const sanitize = (html) => {
    if (!window) return '';
    return createDOMPurify(window).sanitize(html);
};

const applyDomainOverrides = (html, product) => {
    if (product === 'playnixzone') {
        return html.replace(/Edutainment Media Sdn Bhd/g, 'Mobimilia');
    }
    return html;
};

const getTermsAndConditionsTranslated = (product) => {
    switch (product) {
        case 'fun-box':
            return TermsAndConditionsFunBoxEN;
        case 'entertainu':
            return TermsAndConditionsEntertainuEN;
        case 'flixvid':
            return TermsAndConditionsFlixvidEN;
        case 'mixstreamflix':
            return TermsAndConditionsMixstreamflixEN;
        case 'sparkstream':
            return TermsAndConditionsSparkstreamEN;
        case 'zvaigzdeplay':
        case 'zlataplay':
            return TermsAndConditionZvaigzdeplay;
        case 'mobiotv':
            return TermsAndConditionMobiotv;
        case 'nonton-tv':
            if (config.lang === 'id') {
                return TermsAndConditionsNontonID;
            }
            return TermsAndConditionsNonton;
        case 'playnixzone':
            if (config.lang === 'bg') {
                return TermsAndConditionsPlaynixzoneBG;
            }
            return TermsAndConditionsNonton;
        default:
            return TermsAndConditionsMovioEN;
    }
};

const TermsAndConditions = () => {
    const [loading, setLoading] = React.useState(false);
    const [html, setHTML] = React.useState('');
    const { product } = useGetPageConfig();

    const fetchHTML = useCallback(
        async (url) => {
            setLoading(true);
            try {
                const response = await fetch(url);
                if (response.ok) {
                    const html = await response.text();
                    setHTML(applyDomainOverrides(html, product));
                } else {
                    console.warn(`Failed to fetch external FAQ from ${url} (status: ${response.status}). Falling back to local version.`);
                    setHTML(applyDomainOverrides(getTermsAndConditionsTranslated(product), product));
                }
            } catch (error) {
                console.error(`Error fetching external FAQ from ${url}:`, error);
                setHTML(applyDomainOverrides(getTermsAndConditionsTranslated(product), product));
            } finally {
                setLoading(false);
            }
        },
        [product],
    );

    useEffect(() => {
        const url = new URL(dashboardURL);
        url.searchParams.append('pageType', 'terms');
        url.searchParams.append('subdomain', getHostname());
        url.searchParams.append('language', 'en'); // Only English is available as of now
        fetchHTML(url);
    }, [fetchHTML, product]);

    if (loading) return <PageLoader />;

    return (
        <>
            <Header forceHideHamburger />
            <div className="static-pages">
                <div dangerouslySetInnerHTML={{ __html: sanitize(html) }} />
            </div>
        </>
    );
};

export default TermsAndConditions;
